import React from 'react';

const TABS = [
  { id: 'profile_info', label: 'Dados gerais' },
  { id: 'account_security', label: 'Segurança' },
  { id: 'financial', label: 'Info do plano' },
  { id: 'credit_cards', label: 'Cartões de crédito' },
  { id: 'queries', label: 'Consultas Jusfinder' },
  { id: 'features', label: 'Utilização' },
  { id: 'credits', label: 'Benefícios' },
  { id: 'products', label: 'Produtos' },
];

export default function Tabs({ tab, setTab }) {
  return (
    <div className="cd-tabs" role="tablist">
      {TABS.map(({ id, label }) => (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={tab === id}
          className="cd-tab"
          onClick={() => setTab(id)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
